import { startLogin } from '../api.js';
import { theme } from '../theme.js';

export function Login() {
  const accessDenied =
    typeof window !== 'undefined' &&
    new URLSearchParams(window.location.search).get('error') === 'access_denied';
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 20px',
      }}
    >
      <div
        style={{
          width: 460,
          maxWidth: '100%',
          background: theme.color.surface,
          border: `1px solid ${theme.color.border}`,
          boxShadow: '0 4px 20px rgba(12,53,81,0.10)',
        }}
      >
        <div
          style={{
            position: 'relative',
            overflow: 'hidden',
            background: theme.gradient.header,
            padding: '34px 32px',
          }}
        >
          <img
            src="/assets/schoonderwolf-beeldmerk.svg"
            alt=""
            style={{
              position: 'absolute',
              right: -40,
              top: -55,
              height: 230,
              opacity: 0.14,
              transform: 'rotate(10deg)',
              filter: 'brightness(0) invert(1)',
              pointerEvents: 'none',
            }}
          />
          <img
            src="/assets/schoonderwolf-logo.svg"
            alt="Schoonderwolf"
            style={{ height: 38, display: 'block', position: 'relative', filter: 'brightness(0) invert(1)' }}
          />
        </div>

        <div style={{ padding: '26px 32px 30px' }}>
          <h1 style={{ margin: '0 0 20px', fontSize: 20, fontWeight: 700, color: theme.color.text }}>
            Concurrentieanalyse
          </h1>
          {accessDenied && (
            <div
              role="alert"
              style={{
                marginBottom: 18,
                background: theme.color.warnBg,
                border: `1px solid ${theme.color.warnBorder}`,
                color: theme.color.warnText,
                borderRadius: 10,
                padding: '12px 14px',
                fontSize: 13.5,
                lineHeight: 1.5,
              }}
            >
              <strong>Geen toegang.</strong> Je Microsoft-account is geldig, maar heeft (nog) geen
              toegang tot deze applicatie. Neem contact op met de beheerder om toegang te krijgen.
            </div>
          )}
          <div
            style={{
              border: `1px solid ${theme.color.border}`,
              borderRadius: 12,
              padding: '26px 28px',
              textAlign: 'center',
            }}
          >
            <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>Inloggen</div>
            <p style={{ margin: '0 0 20px', fontSize: 13.5, color: theme.color.muted, lineHeight: 1.55 }}>
              Log in met je Schoonderwolf-account om concurrentieanalyses te starten en te beheren.
            </p>
            <button
              onClick={() => startLogin('/')}
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 10,
                background: theme.color.surface,
                border: `1px solid ${theme.color.borderStrong}`,
                borderRadius: 8,
                padding: '12px 16px',
                fontSize: 14,
                fontWeight: 600,
                color: theme.color.text,
                cursor: 'pointer',
                fontFamily: 'inherit',
              }}
            >
              <svg width="17" height="17" viewBox="0 0 21 21" aria-hidden="true">
                <rect x="0" y="0" width="10" height="10" fill="#F25022" />
                <rect x="11" y="0" width="10" height="10" fill="#7FBA00" />
                <rect x="0" y="11" width="10" height="10" fill="#00A4EF" />
                <rect x="11" y="11" width="10" height="10" fill="#FFB900" />
              </svg>
              Inloggen met Microsoft
            </button>
            <p style={{ margin: '18px 0 0', fontSize: 12.5, color: theme.color.muted, lineHeight: 1.6 }}>
              Single sign-on via Microsoft Entra. Nieuwe medewerkers zonder toegewezen rechten krijgen
              automatisch de rol <strong>Kijker</strong>.
            </p>
          </div>
          <div style={{ marginTop: 20, textAlign: 'center', fontSize: 12.5, color: theme.color.muted }}>
            Schoonderwolf Groep · Concurrentieanalyse
          </div>
        </div>
      </div>
    </div>
  );
}
